import type { AuthInfo } from '~/types/interfaces'
import { useApiBase } from './useApiBase'

interface GoogleAuthResponse {
  status: string
  /** `auth.isNewUser` = 新規登録後の初回入場か (#860)。GA4 `sign_up` の送出判定に使う。 */
  auth?: AuthInfo & { isNewUser?: boolean }
  error?: { error: string, message: string }
}

export function useGoogleAuth() {
  const config = useRuntimeConfig()
  const { apiBase, publicFetch } = useApiBase()

  const cognitoDomain = config.public.cognitoDomain as string
  const cognitoOAuthClientId = config.public.cognitoOAuthClientId as string

  const isGoogleLoginAvailable = computed(() => {
    return !!cognitoDomain && !!cognitoOAuthClientId
  })

  /**
   * Cognito /oauth2/authorize URL を構築して Google ログイン画面へリダイレクト
   */
  const buildGoogleAuthUrl = (): string => {
    const redirectUri = `${window.location.origin}/auth/google/callback`
    const params = new URLSearchParams({
      identity_provider: 'Google',
      response_type: 'code',
      client_id: cognitoOAuthClientId,
      scope: 'openid email profile',
      redirect_uri: redirectUri,
    })
    return `https://${cognitoDomain}/oauth2/authorize?${params.toString()}`
  }

  /**
   * Authorization code をバックエンドに送信してトークンに交換
   */
  const exchangeGoogleCode = async (code: string): Promise<GoogleAuthResponse> => {
    const redirectUri = `${window.location.origin}/auth/google/callback`
    return await publicFetch<GoogleAuthResponse>(
      `${apiBase}/api/v1/auth/google/callback`,
      {
        method: 'POST',
        body: { code, redirectUri },
      },
    )
  }

  return {
    isGoogleLoginAvailable,
    buildGoogleAuthUrl,
    exchangeGoogleCode,
  }
}
